import { render, staticRenderFns } from "./HistoricLift.vue?vue&type=template&id=bc70b970"
import script from "./HistoricLift.vue?vue&type=script&lang=js"
export * from "./HistoricLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports